<template>
    <div class="float-left">
        <i
            class="fa fa-search-plus fa-lg icon-button"
            title="Documentos da Despesa"
            @click.stop="abrirModal()">
        </i>
        <b-modal
            id="modalPrestacaoFinal"
            size="xl"
            v-model="mostrarModal"
            no-close-on-backdrop>
            <div slot="modal-title">
                Documentos da Despesa
            </div>
            <app-erros-box
                :erros="erros"
                v-if="erros.length > 0">
            </app-erros-box>

            <div>
                <b-row>
                    <b-col sm="12" md="2">
                        <b-form-group>
                            <label>Prestação Mensal</label>
                            <b-input-group>
                                <b-form-input
                                    type="text"
                                    v-model="prestacaoFinal.idPrestacaoContasMensal"
                                    disabled
                                ></b-form-input>
                            </b-input-group>
                        </b-form-group>
                    </b-col>
                    <b-col sm="12" md="2">
                        <b-form-group>
                            <label>Despesa</label>
                            <b-input-group>
                                <b-form-input
                                    id="idPrestacaoContasFinal"
                                    type="text"
                                    v-model="prestacaoFinal.idPrestacaoContasFinal"
                                    disabled
                                ></b-form-input>
                            </b-input-group>
                        </b-form-group>
                    </b-col>
                    <b-col sm="12" md="2">
                        <b-form-group>
                            <label>Data Emissão</label>
                            <b-input-group>
                                <b-form-input
                                    type="text"
                                    v-model="dtEmissao"
                                    disabled
                                ></b-form-input>
                            </b-input-group>
                        </b-form-group>
                    </b-col>

                    <b-col sm="12" md="2">
                        <b-form-group>
                            <label>Valor</label>
                            <b-input-group>
                                <money
                                    v-model="prestacaoFinal.nuValor"
                                    v-bind="money"
                                    class="form-control text-right"
                                    disabled>
                                </money>
                                <b-form-invalid-feedback>Total Despesas é obrigatória</b-form-invalid-feedback>
                            </b-input-group>
                        </b-form-group>
                    </b-col>
                </b-row>

                <b-row>
                    <b-col sm="12" md="12">
                        <b-card no-body>
                            <b-card-header>
                                <span class="h5">
                                    Documentos
                                </span>
                            </b-card-header>
                            <b-card-body>
                                <app-tabela
                                    idTabela="tblPrestacaoFinal"
                                    :itens="DocumentoConvenio"
                                    :campos="campos"
                                    :itensPorPagina="itensPorPagina"
                                    :bordered="false"
                                    :small="false">
                                    <template slot="botoes">
                                        <b-button-group class="float-right" v-if="permiteCadastrarDocumentos">
                                            <btn-inserir-documento
                                                class="mr-2"
                                                :idPrestacaoFinal="prestacaoFinal.idPrestacaoContasFinal"
                                                :convenio="convenio"
                                                :dataServicos="dataServicos"
                                                @atualizarLista="listarDocumentos()">
                                            </btn-inserir-documento>
                                        </b-button-group>
                                    </template>
                                    <template slot="acoes" slot-scope="data">
                                        <span class="text-primary float-left">
                                            <btn-atualizar-documento
                                                :idPrestacaoFinal="prestacaoFinal.idPrestacaoContasFinal"
                                                :convenio="convenio"
                                                :dataServicos="dataServicos"
                                                :documento="data"
                                                @atualizarLista="listarDocumentos()"
                                                v-if="data.status == 1">
                                            </btn-atualizar-documento>
                                        </span>
                                        <span class="text-danger float-left" v-if="permiteExcluirDocumentos">
                                            <i
                                                class="fa fa-trash fa-lg icon-button"
                                                title="Excluir Documento"
                                                @click.stop="excluir(data.id_Documento)"
                                                v-if="prestacaoFinal.codSituacao == 0 && convenio.idSituacaoConvenio != 9"
                                            ></i>
                                        </span>
                                        <span class="text-success float-left mr-2">
                                            <i
                                                class="fa fa-download fa-lg icon-button"
                                                title="Download"
                                                @click.stop="download(data)"
                                            ></i>
                                        </span>
                                        <span class="text-primary float-left mr-2">
                                            <Visualizar
                                                :parentData="data"
                                                :dataServicos="dataServicos">
                                            </Visualizar>
                                        </span>
                                        <span
                                            class="text-danger float-left mr-1"
                                            v-if="data.status == 1">
                                            <i
                                                class="fa fa-exclamation-circle fa-lg icon-button"
                                                title="Justificativa"
                                                @click.stop="mostrarPendencia(data.pendencia)"
                                            ></i>
                                        </span>
                                    </template>
                                    <template slot="nuValor" slot-scope="data">
                                        <p class="text-right m-0">
                                            {{ data.nuValor | currency }}
                                        </p>
                                    </template>
                                    <template slot="dtEmissao" slot-scope="data">
                                        <p class="text-left m-0">
                                            {{ data.dtEmissao ? $moment(data.dtEmissao).format('DD/MM/YYYY') : '' }}
                                        </p>
                                    </template>
                                    <template slot="statusDescricao" slot-scope="data">
                                        <app-status
                                            :status="data.statusDescricao.toUpperCase()"
                                        ></app-status>
                                    </template>
                                </app-tabela>
                            </b-card-body>
                        </b-card>
                    </b-col>
                </b-row>
            </div>

        </b-modal>
    </div>
</template>


<script>
    import BtnInserirDocumento from '../cadastros/documentos/BtnInserirDocumento.vue'
    import BtnAtualizarDocumento from '../cadastros/documentos/BtnAtualizarDocumento.vue'
    import Visualizar from './VisualizarDocumento.vue'

    export default {
        components: {
            BtnInserirDocumento,
            BtnAtualizarDocumento,
            Visualizar
        },

        props: {
            convenio: {
                type: Object,
                default: () => ({})
            },
            prestacaoFinal: {
                type: Object,
                default: () => ({})
            },
            dataServicos: {
                type: Object
            },
            permiteCadastrarDocumentos: {
                type: Boolean,
                default: () => false
            },
            permiteExcluirDocumentos: {
                type: Boolean,
                default: () => false
            }
        },

        data() {
            return {
                mostrarModal: false,
                erros: [],
                itensPorPagina: 5,
                DocumentoConvenio: [],
                dtEmissao: null,
                money: {
                    decimal: ',',
                    thousands: '.',
                    prefix: 'R$ ',
                    suffix: '',
                    precision: 2,
                    masked: false
                },
                campos: [
                    {
                        key: 'id_Documento',
                        label: 'id',
                        filterable: true,
                        sortable: true
                    },
                    {
                        key: 'tipoDocumento.vcDescricaoTipoDocumento',
                        label: 'Tipo Documento',
                        filterable: true,
                        sortable: true
                    },
                    {
                        key: 'vcDescricaoDocumento',
                        label: 'Descrição',
                        filterable: true,
                        sortable: true
                    },
                    {
                        key: 'vcNomeArquivo',
                        label: 'Arquivo',
                        filterable: true,
                        sortable: true
                    },
                    {
                        key: 'statusDescricao',
                        label: 'Status',
                        filterable: true,
                        sortable: true
                    },
                    {
                        key: 'acoes',
                        label: ''
                    }
                ]
            }
        },

        methods: {
            abrirModal() {
                this.mostrarModal = true;
                this.listarDocumentos()
                this.dtEmissao = this.$moment(this.prestacaoFinal.dtEmissao, 'YYYY-MM-DD').format('DD/MM/YYYY');
            },

            fecharModal() {
                this.mostrarModal = false;
            },

            listarDocumentos(){
                if (this.prestacaoFinal.idPrestacaoContasFinal > 0){
                    this.$store.dispatch('addRequest')
                    this.dataServicos.ListarDocumentosPrestacaoFinal(this.prestacaoFinal.idPrestacaoContasFinal).then(
                        response => {
                            if (response) {
                                if (response.success) {
                                    this.DocumentoConvenio = response.data

                                } else {
                                    this.erros = response.errors
                                }
                            }
                            this.$store.dispatch('removeRequest')
                        }
                    )
                }
            },

            excluir(id){
                this.$store.dispatch('addRequest')
                    this.dataServicos.ExcluirDocumentoConvenio(id).then(
                        response => {
                            if (response) {
                                this.listarDocumentos()
                            }
                            this.$store.dispatch('removeRequest')
                        }
                    )
            },

            download(doc){
                this.$store.dispatch('addRequest')
                this.dataServicos.downloadDocumento(doc.id_Documento)
                .then(response => {
                    if (response) {
                        if (response.type === 'application/json') {
                            this.$toast.error(
                                'Erro no Download!!!',
                                'ERROR',
                                this.$toastConfig.error
                            )
                        } else {
                            this.$download(
                                response,
                                doc.vcNomeArquivo
                            )
                        }
                    }
                    this.$store.dispatch('removeRequest')
                })
            },

            mostrarPendencia(pendencia) {
                this.$swal({
                    title: 'Pendência',
                    html: `<b>${pendencia}</b>`,
                    icon: 'warning',
                })            
            },
        }
    }
</script>
